import { connect, useSelector } from 'react-redux'
import { FooterComponent } from './FooterComponent'
import { injectIntl } from 'react-intl'
import type { Dispatch } from 'redux'
import { sendNewsletterSubscription } from 'shared/store/user'
import type { RootState } from 'shared/store/reducers'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const { footer, copyright } = state.applicationState
    const { subscriptionSuccess, trySubscription } = state.userState
    const isActiveZendesk =
        state.featuresState.available.includes(
            featureCodes.ACTIVATION_ZENDESK_REDIRECTION
        ) ?? false
    return {
        footer,
        copyright,
        isActiveZendesk,
        subscriptionSuccess,
        trySubscription
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    sendNewsletterSubscription: (email: string) =>
        dispatch(sendNewsletterSubscription(email))
})

const Footer = connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(FooterComponent))

export { Footer }
